import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { AppPages } from '@constants/app-pages';
import { ReservaService } from '@infra/reserva/reserva.service';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
})
export class StepperComponent {
  isLinear = true;
  @Input() selectedIndex!: number;
  pagamentoStripe = 'N';
  constructor(private router: Router, private reservaService: ReservaService) { 
    this.pagamentoStripe = sessionStorage.getItem('pagamentoStripe')
  }

  async onClickStep(step: number) {
    this.selectedIndex > parseInt(this.reservaService.maxStepAllowed)
      ? (this.reservaService.maxStepAllowed = this.selectedIndex.toString())
      : null;
    if (step !== this.selectedIndex && step <= parseInt(this.reservaService.maxStepAllowed))

      switch (step) {
        case 0:
          this.router.navigateByUrl(AppPages.HOME);
          break;
        case 1:
          this.router.navigateByUrl(AppPages.VEHICLES, { state: { useDataFromStorage: true } });
          break;
        case 2:
          await this.reservaService.clearProtectionsTariffAndAdditionalsData();
          this.router.navigateByUrl(AppPages.ADDITIONALS);
          break;
        case 3:
          this.router.navigateByUrl(AppPages.PERSON);
          break;
        case 4:
          this.router.navigateByUrl(AppPages.PAYMENT);
          break;
      }
  }
}
